import {Component, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';

import * as d3 from 'd3';
import {TriggerEvent} from '../../../../afb-api/models/trigger-event';

@Component({
  selector: '[awair-small-dot]',
  templateUrl: './small-dot.component.html',
  styleUrls: ['./small-dot.component.scss']
})
export class SmallDotComponent implements OnInit {

  @Output() hoverEvent: EventEmitter<any> = new EventEmitter();
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  @Output() outEvent: EventEmitter<any> = new EventEmitter();

  private triggerEventListOfDeviceList: Array<TriggerEvent[]>;
  private isInitialized: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  update(svgGroup: any, triggerEventListOfDeviceList: Array<TriggerEvent[]>, xScale: any, yScale: any, yMin: number) {
    if (triggerEventListOfDeviceList) {
      this.triggerEventListOfDeviceList = triggerEventListOfDeviceList;
      if (triggerEventListOfDeviceList.length === 0) {
        d3.select(this.el.nativeElement)
          .selectAll('.te-dot')
          .remove();

      } else {
        if (this.isInitialized) {
          d3.select(this.el.nativeElement)
            .selectAll('.te-dot')
            .remove();
        }

        for (let i = 0; i < triggerEventListOfDeviceList.length; i++) {
          d3.select(this.el.nativeElement)
            .selectAll('te-dot')
            .data(triggerEventListOfDeviceList[i])
            .enter().append('circle')
            .attr('class', 'te-dot')
            .style('stroke', '#ACB4BB')
            .style('stroke-width', '2px')
            .style('cursor', 'pointer')
            .style('fill', '#FFFFFF')
            .attr('r', 3)
            .attr('cx', (d: TriggerEvent) => xScale(new Date(d.timestamp)))
            .attr('cy', (d: TriggerEvent) => yScale(yMin))
            .on('mousemove', (d: TriggerEvent) => {
              this.hoverEvent.emit({ triggerEvent: d, deviceIndex: i });
            })
            .on('click', (d: TriggerEvent) => {
              this.clickEvent.emit(d);
            })
            .on('mouseout', () => {
              this.outEvent.emit();
            });

          this.isInitialized = true;
        }
      }
    }
  }
}
